<script setup lang="ts">
defineProps<{
  review: string
}>()
</script>

<template>
  <div>
    <BaseIcon class="mb-5 translate-x-px" name="quotes" filled />

    <p class="mb-6">
      {{ review }}
    </p>
  </div>
</template>
